// The map: MapLibre with the Protomaps basemap style, reading vector tiles straight
// out of the planet PMTiles archive the app serves, with HTTP range requests.
import * as maplibregl from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";
import { Protocol } from "pmtiles";
import { layers, namedFlavor } from "@protomaps/basemaps";
import { directions } from "./directions.js";

// MapLibre parses tiles in a web worker loaded from its own file, copied next to
// this bundle by the build.
maplibregl.setWorkerUrl("/maplibre-gl-worker.mjs");
maplibregl.addProtocol("pmtiles", new Protocol().tile);

// Fonts and sprites are self-hosted (vendored, unpacked into dist by bin/unpack-assets).
const origin = window.location.origin;
// The planet build to read, at its own URL: the same bytes whichever server answers,
// cached for good. A new build comes with a new URL, on the next page load.
const planet = await (await fetch("/tiles/planet.json")).json();
const flavor = namedFlavor("light");

// 3D buildings: extruded from z14, drawn over the roads and under the labels. About
// half the buildings in OSM have no height; they get a typical low-rise one.
const DEFAULT_HEIGHT = 8;
const fade = (from, to) => ["interpolate", ["linear"], ["zoom"], 14, from, 15, to];
const basemap = layers("protomaps", flavor, { lang: "en" }).map((layer) =>
  layer.id === "buildings" ? { ...layer, paint: { ...layer.paint, "fill-opacity": fade(0.5, 0) } } : layer,
);
const firstLabel = basemap.findIndex((layer) => layer.type === "symbol");
basemap.splice(firstLabel, 0, {
  id: "buildings-3d",
  type: "fill-extrusion",
  source: "protomaps",
  "source-layer": "buildings",
  minzoom: 14,
  filter: ["in", "kind", "building", "building_part"],
  paint: {
    "fill-extrusion-color": flavor.buildings,
    "fill-extrusion-height": ["coalesce", ["get", "height"], DEFAULT_HEIGHT],
    "fill-extrusion-base": ["coalesce", ["get", "min_height"], 0],
    "fill-extrusion-opacity": fade(0, 0.8),
  },
});

const map = new maplibregl.Map({
  container: "map",
  center: [15.0, 62.0], // [lng, lat]: Sweden
  zoom: 4,
  hash: true,
  style: {
    version: 8,
    glyphs: `${origin}/fonts/{fontstack}/{range}.pbf`,
    sprite: `${origin}/sprites/v4/light`,
    sources: {
      protomaps: {
        type: "vector",
        url: `pmtiles://${origin}${planet.url}`,
        attribution:
          '<a href="https://protomaps.com">Protomaps</a> © <a href="https://openstreetmap.org/copyright">OpenStreetMap</a>',
      },
    },
    layers: basemap,
  },
});
// Tilt with right-drag or ctrl-drag (two fingers on touch screens).
map.addControl(new maplibregl.NavigationControl({ visualizePitch: true }));
directions(map);
